module.exports = __webpack_public_path__ + "img/describe1.1f900a3f.png";